export default __webpack_public_path__ + "static/media/dragndropred.37a6a642.png";